import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { map } from 'rxjs';
import type { AppModuleNavItem } from '../../core/navigation/app-modules';
import { UiBadge, UiButton, UiEmptyState, UiPageHeader } from '../../shared/ui';

@Component({
  selector: 'app-module-placeholder-page',
  imports: [RouterLink, UiBadge, UiButton, UiEmptyState, UiPageHeader],
  templateUrl: './module-placeholder.page.html',
  styleUrl: './module-placeholder.page.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModulePlaceholderPage {
  private readonly route = inject(ActivatedRoute);

  private readonly routeModule = toSignal(this.route.data.pipe(map((data) => data['module'] as AppModuleNavItem)), {
    initialValue: {
      label: 'Área',
      path: '/',
      exact: true,
      icon: 'heroRectangleGroup',
      eyebrow: 'Automato',
      description: 'Área operacional preparada para implementação.',
      status: 'Planejado',
    },
  });

  readonly module = computed(() => this.routeModule());
}
